import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  OutlinedInput,
  Grid,
  CircularProgress,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Pagination from 'ui-component/pagination/pagination';

import styles from './style.module.css';
import ApiCall from 'services/axiosConfig';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material/styles';

function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const NotificationModal = (props) => {
  const {
    open,
    closeModal,
    currentPg,
    totalPg,
    notificationData,
    onPageChange,
  } = props;
  const theme = useTheme();
  const [modalStyle] = useState(getModalStyle);
  const [isLoading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(currentPg);
  const [totalPages, setTotalPages] = useState(totalPg);

  useEffect(() => {
    setCurrentPage(currentPg);
    setTotalPages(totalPg);
  }, [currentPg, totalPg, notificationData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    onPageChange(page, 7);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        closeModal();
      }}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <div style={modalStyle} className={styles.addDepartment_modal}>
        <div
          style={{
            position: 'relative',
            padding: '7px',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '50%',
              right: 1,
              cursor: 'pointer',
              transform: 'translateY(-50%)',
            }}
            onClick={() => {
              closeModal();
            }}
          >
            <CloseOutlinedIcon style={{ color: '#9A9A9A' }} />
          </div>
        </div>
        <p className={styles.modal_title}>Notifications</p>

        <Grid container row={true} spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <CircularProgress
                  color='secondary'
                  sx={{ margin: '2rem 10rem' }}
                />
              </div>
            ) : (
              <Box
                width={'100%'}
                height={'400px'}
                borderColor={theme.palette.secondary.main}
                border={1}
                borderRadius={'8px'}
                p={2}
                style={{ overflowY: 'auto' }}
              >
                {notificationData &&
                  notificationData.map((notification, index) => (
                    <div key={index}>
                      <Box paddingBottom={2} key={index}>
                        <Box display={'flex'} gap={1}>
                          <p
                            style={{
                              fontStyle: 'italic',
                              color: theme.palette.secondary.main,
                              margin: 0,
                            }}
                          >
                            {notification.type}:
                          </p>
                          <p
                            style={{
                              color: theme.palette.common.black,
                              margin: 0,
                              fontSize: '16px',
                              fontStyle: 'italic',
                              fontWeight: '500',
                            }}
                          >
                            {notification.message}
                          </p>
                        </Box>
                        <p
                          style={{
                            color: theme.palette.primary.main,
                            margin: 0,
                          }}
                        >
                          {dayjs(notification.createdAt).format('MM-DD-YYYY')}
                          &nbsp;&nbsp;
                          {new Date(notification.createdAt).toLocaleTimeString(
                            'en-GB',
                            {
                              hour12: true,
                              hour: '2-digit',
                              minute: '2-digit',
                            }
                          )}
                        </p>
                      </Box>
                    </div>
                  ))}
              </Box>
            )}
          </Grid>
          <div
            id='pagination'
            style={{
              backgroundColor: theme.palette.background.default,
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <Pagination
              current={currentPage}
              onPageChange={handlePageChange}
              total={totalPages}
            />
          </div>

          <Grid item xs={12}>
            <Grid
              container
              justifyContent='center'
              alignItems='center'
              spacing={2}
            >
              <Grid item lg={8} md={8} sm={12} xs={12}>
                <Box py={2}>
                  <LoadingButton
                    variant='contained'
                    color='secondary'
                    sx={{ fontSize: '20px', fontWeight: '500' }}
                    style={{ width: '100%' }}
                    onClick={() => {
                      closeModal();
                    }}
                  >
                    Close
                  </LoadingButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

export default NotificationModal;
